
    import Vue from 'vue';
    import DatePickerMenu from "./DatePickerMenu.vue";
    import TimePicker from "./TimePicker.vue";
    import SchedulerEvent from "@/models/schedulerEvent";
    import PartyService from "../services/party.service";
    import utils from "@/services/utils";
    import {eventBus} from "@/services/event-bus";

    export default Vue.extend({
        props: ['value', 'activities', 'dialog', 'editing', 'userType'],
        data() {
            return {
                durations: [
                    '30',
                    '50',
                    '60',
                    '90',
                    '120',
                    '150',
                    '180',
                ],
                statuses: [
                    'CONFIRMED',
                    'CANCELLED_FREE',
                    'CANCELLED_PAID',
                ],
                paymentStatuses: [
                    'PAID',
                    'UNPAID'
                ],
                parties: []
            }
        },
        computed: {
            appointment: {
                get(): any {
                    return this.value;
                },
                set(val: any) {
                    this.$emit('input', val);
                }
            },
        },
        components: {
            datePickerMenu: DatePickerMenu,
            timePicker: TimePicker
        },
        watch: {
            dialog: function (val, oldVal) {
                this.updateParties();
                if (val) {
                    if (this.activities.length === 1) {
                        this.appointment.activity = this.activities[0];
                    }
                }
            }
        },
        methods: {
            addEvent(appointment: SchedulerEvent) {
                if (this.editing) {
                    this.$emit('update-event', appointment);
                } else {
                    this.$emit('add-event', appointment);
                }
            },
            hideMenu() {
                this.$emit('hide-event-form');
            },
            updateParties() {
                if (utils.isNotNull(this.value.activity) && utils.isNotNull(this.value.activity.id)) {
                    if (this.userType === 'therapist') {
                        this.doUpdateParties(PartyService
                            .allPatientsForActivityAndDateRange(this.appointment.activity.id, this.appointment.dateFrom, this.appointment.timeFrom, this.appointment.duration));
                    } else {
                        this.doUpdateParties(PartyService
                            .allTherapistsForActivityAndDateRange(this.appointment.activity.id, this.appointment.dateFrom, this.appointment.timeFrom, this.appointment.duration));
                    }
                }
            },
            setParties: function (p:[]) {
                return this.parties = p;
            },
            doUpdateParties(p: Promise<any>) {
                // eslint-disable-next-line no-console
                console.log(p);
                p.then(p => this.setParties(p))
                    .catch(e => eventBus.$emit('error', e));

            },
            toLabel(item: any): string {
                return `${item.name} ${item.surname}`;
            },
            timeStep: (m: number) => m % 10 === 0,
        },
        errorCaptured(err: Error, vm: Vue, info: string): boolean | void {
            eventBus.$emit('error', err.message);
        }
    });
